/* eslint-disable react/no-array-index-key */
import { FC } from 'react';

type WidgetTableSimpleLoaderProps = {
  rows: number;
};

const WidgetTableSimpleLoader: FC<WidgetTableSimpleLoaderProps> = ({
  rows = 5,
}) => (
  <div className="col-12 col-xl-6 mb-4">
    <div className="card card-bordered h-100">
      <div className="card-inner">
        <p className="placeholder-glow ">
          <span className="placeholder col-4    h-15px mb-2" />
          <span className="placeholder offset-8 h-15px mb-2" />

          <span className="placeholder col-7    h-15px mb-4" />
          <span className="placeholder offset-5 h-15px mb-4" />

          {new Array(5).fill(null).map((_, index) => (
            <span key={`main-row-${index}`}>
              <span className="placeholder col-6    h-20px mb-2" />
              <span className="placeholder offset-1 h-20px mb-2" />
              <span className="placeholder col-2    h-20px mb-2" />
              <span className="placeholder offset-1 h-20px mb-2" />
              <span className="placeholder col-2    h-20px mb-2" />
            </span>
          ))}

          <br />
          <br />

          <span className="placeholder col-4    h-15px mb-2" />
          <span className="placeholder offset-8 h-15px mb-2" />

          <span className="placeholder col-7    h-15px mb-4" />
          <span className="placeholder offset-5 h-15px mb-4" />

          {new Array(5).fill(null).map((_, index) => (
            <span key={`secondary-row-${index}`}>
              <span className="placeholder col-6    h-20px mb-2" />
              <span className="placeholder offset-1 h-20px mb-2" />
              <span className="placeholder col-2    h-20px mb-2" />
              <span className="placeholder offset-1 h-20px mb-2" />
              <span className="placeholder col-2    h-20px mb-2" />
            </span>
          ))}
        </p>
      </div>
    </div>
  </div>
);

export default WidgetTableSimpleLoader;
